import { GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import { ImagePreviewBox } from "./components/ImagePreviewBox";
import { Typography } from "@mui/material";
import { Link } from "react-router";

const BASE_TRANSLATION_KEY = "fields";

export type TabColumnInfo = {
  filterField: string;
  path: string;
  hasRowSelection?: boolean;
  columns?: string[];
};

export const getOrderListColumns = (
  translate: (_key: string) => string,
  locales: Intl.LocalesArgument,
): GridColDef<GridValidRowModel>[] => [
  {
    field: "images",
    headerName: translate(`${BASE_TRANSLATION_KEY}.images`),
    minWidth: 150,
    sortable: false,
    renderCell: (params) => {
      const items: { imageUrl: string; productCode: string }[] =
        params.row.orderItems;
      const filteredItems = items.filter((item) => !!item.imageUrl);
      const images = filteredItems.map((item) => item.imageUrl);
      const asins = filteredItems.map((item) => item.productCode);
      return <ImagePreviewBox images={images} asins={asins} />;
    },
  },
  {
    field: "barcode",
    headerName: translate(`${BASE_TRANSLATION_KEY}.orderId`),
    minWidth: 150,
    renderCell: (params) => {
      return (
        <Typography
          component={Link}
          to={`${params.value}`}
          variant="body2"
          color="primary"
          noWrap
          sx={{ cursor: "pointer", textDecoration: "none" }}
        >
          {params.value}
        </Typography>
      );
    },
  },
  {
    field: "storeName",
    headerName: translate(`${BASE_TRANSLATION_KEY}.storeName`),
    flex: 1,
  },
  {
    field: "countryCode",
    headerName: translate(`${BASE_TRANSLATION_KEY}.destinationCountry`),
    flex: 1,
  },
  {
    field: "carrierName",
    headerName: translate(`${BASE_TRANSLATION_KEY}.carrierName`),
    flex: 1,
    valueFormatter: (value) => value ?? "-",
  },
  {
    field: "status",
    headerName: translate(`${BASE_TRANSLATION_KEY}.status`),
    flex: 1,
    valueFormatter: (value) => {
      return translate(`statuses.${value}`);
    },
  },
  {
    field: "orderDate",
    flex: 1,
    headerName: translate(`${BASE_TRANSLATION_KEY}.orderDate`),
    valueFormatter: (value) => {
      const date = new Date(value).toLocaleDateString(locales);
      const time = new Date(value).toLocaleTimeString(locales);

      return `${date} ${time}`;
    },
  },
];
